export const validationSchema = {
    last_name: {
        required: '姓は必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value =>
            /^[ぁ-んA-Z]+$/.test(value) ||  // ひらがな + 大文字アルファベット
            /^[ァ-ヴー・A-Z]+$/.test(value) ||  // カタカナ + 大文字アルファベット + 「・」
            /^[一-龥々A-Z]+$/.test(value) ||  // 漢字・繰り返し記号 + 大文字アルファベット
            /^[ぁ-んァ-ン一-龥々・A-Z]+$/.test(value) ||  // ひらがな、カタカナ、漢字・繰り返し記号 + 大文字アルファベット + 「・」
            '漢字・カタカナ（全角）・ひらがな・アルファベットで入力してください',
    },
    first_name: {
        required: '名は必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value =>
            /^[ぁ-んA-Z]+$/.test(value) ||  // ひらがな + 大文字アルファベット
            /^[ァ-ヴー・A-Z]+$/.test(value) ||  // カタカナ + 大文字アルファベット + 「・」
            /^[一-龥々A-Z]+$/.test(value) ||  // 漢字・繰り返し記号 + 大文字アルファベット
            /^[ぁ-んァ-ン一-龥々・A-Z]+$/.test(value) ||  // ひらがな、カタカナ、漢字・繰り返し記号 + 大文字アルファベット + 「・」
            '漢字・カタカナ（全角）・ひらがな・アルファベットで入力してください',
    },
    last_name_kana: {
        required: 'カナは必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[ァ-ヴ][ァ-ヴー・]*$/.test(value) ||
            'カタカナ（全角）で入力してください',
    },
    first_name_kana: {
        required: 'カナは必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[ァ-ヴ][ァ-ヴー・]*$/.test(value) ||
            'カタカナ（全角）で入力してください',
    },
    closest_line: {
        required: '路線は必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[一-龥ぁ-んァ-ンー々]+(?![0-9])$/.test(value) || // ひらがな・カタカナ・漢字・繰り返し記号のみ・アルファベットと数字は不可(ごちゃ混ぜも可)
            /^J[Rr]/.test(value) || // アルファベットはJR始まりのみ許可 (例)JR山手線
            '漢字・カタカナ（全角）・ひらがなで入力してください',
    },
    closest_station: {
        required: '駅名は必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[一-龥ぁ-んァ-ンー々]+(?![0-9])$/.test(value) || // ひらがな・カタカナ・漢字・繰り返し記号のみ・アルファベットと数字は不可(ごちゃ混ぜも可)
            '漢字・カタカナ（全角）・ひらがなで入力してください',
    },
    closest_line2: {
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[一-龥ぁ-んァ-ンー々]+(?![0-9])$/.test(value) || // ひらがな・カタカナ・漢字・繰り返し記号のみ・アルファベットと数字は不可(ごちゃ混ぜも可)
            /^J[Rr]/.test(value) ||
            '漢字・カタカナ（全角）・ひらがなで入力してください',
    },
    closest_station2: {
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[一-龥ぁ-んァ-ンー々]+(?![0-9])$/.test(value) || // ひらがな・カタカナ・漢字・繰り返し記号のみ・アルファベットと数字は不可(ごちゃ混ぜも可)
            '漢字・カタカナ（全角）・ひらがなで入力してください',
    },
    school_name: {
        required: '何年制かは必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[一-龥々ぁ-んァ-ンＡ-Ｚａ-ｚA-Za-z0-9\s・]+$/.test(value) ||
            '漢字・カタカナ（全角）・ひらがな・アルファベット・数字（半角）・記号（・）で入力してください',
    },
    school_subject: {
        required: '学校種別は必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[一-龥々ぁ-んァ-ンＡ-Ｚａ-ｚA-Za-z0-9\s・]+$/.test(value) ||
            '漢字・カタカナ（全角）・ひらがな・アルファベット・数字（半角）・記号（・）で入力してください',
    },
    job_title: {
        required: '職種分類は必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[^ー][ぁ-んァ-ヴー一-龥々A-Za-z・\s]+$/.test(value) ||  // 先頭に「ー」が来ない、ひらがな・カタカナ・漢字・アルファベット・「・」・スペースの組み合わせ
            '漢字・カタカナ（全角）・ひらがな・アルファベットで入力してください',
    },
    job_title2: {
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[^ー][ぁ-んァ-ヴー一-龥々A-Za-z・\s]+$/.test(value) ||  // 先頭に「ー」が来ない、ひらがな・カタカナ・漢字・アルファベット・「・」・スペースの組み合わせ
            '漢字・カタカナ（全角）・ひらがな・アルファベットで入力してください',
    },
    skillTags: {
        required: '得意なスキルは必須です',
    },
    qualification_name: (year, month) => ({
        required: {
            value: year || month,
            message: '1文字以上入力してください',
        },
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => {
            // 任意入力のため、値が空で「保存」された場合は、記号に関するバリデーションをスキップ
            if (!value) return true;

            // 値が空出ない場合のバリデーション
            const regex = /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/;
            return regex.test(value) || '全角記号で入力してください';
        }
    }),
    qualification_year: (name, month) => ({
        required: {
            value: (name || month),
            message: '選択してください',
        },
    }),
    qualification_month: (name, year) => ({
        required: {
            value: (name || year),
            message: '選択してください',
        },
    }),
    project_name: {
        required: 'プロジェクト名は必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/.test(value) ||
            '全角記号で入力してください',
    },
    overview: {
        required: '業務概要は必須です',
        maxLength: {
            value: 500,
            message: '500文字以内で入力してください',
        },
        validate: value => /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/.test(value) ||
            '全角記号で入力してください',
    },
    select: {
        required: {
            value: true,
            message: '選択してください',
        },
        notDefaultOption: {
            value: (value) => value !== '',
            message: '選択してください',
        },
    },
    email: {
        required: 'メールアドレスは必須です',
        maxLength: {
            value: 255,
            message: 'メールアドレスは255文字以内で入力してください',
        },
        pattern: {
            value: /^[a-zA-Z0-9]((?!\.\.)[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-])*[a-zA-Z0-9]@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*$/
            ,
            message: '有効なメールアドレスを入力してください',
        },
    },
    password: {
        required: 'パスワードは必須です',
        minLength: {
            value: 8,
            message: 'パスワードは8文字以上で入力してください',
        },
        pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
            message: 'パスワードは半角英数の大文字と小文字、記号を含めてください',
        },
    },
    pwd_confirm: {
        required: 'パスワード再入力は必須です',
        validate: (value, context) =>
            value === context.password || 'パスワードが一致しません',
    },
    terms: {
        required: '利用規約とプライバシーポリシーに同意してください',
    },
    skillsheet_name: {
        required: 'スキルシート名は必須です',
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => /^[^!"#$%&'()\npm*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/.test(value) ||
            '全角記号で入力してください',
    },
    career_overview: {
        required: '経歴概要は必須です',
        maxLength: {
            value: 1000,
            message: '1000文字以内で入力してください',
        },
        validate: value => /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/.test(value) ||
            '全角記号で入力してください',
    },
    speciality: {
        required: '得意分野は必須です',
        maxLength: {
            value: 500,
            message: '500文字以内で入力してください',
        },
        validate: value => /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/.test(value) ||
            '全角記号で入力してください',
    },
    future_direction: {
        required: '今後の方向性は必須です',
        maxLength: {
            value: 1000,
            message: '1000文字以内で入力してください',
        },
        validate: value => /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/.test(value) ||
            '全角記号で入力してください',

    },
    code: {
        required: '認証コードは必須です',
        minLength: {
            value: 6,
            message: '認証コードは6文字以上で入力してください',
        },
        maxLength: {
            value: 6,
            message: '認証コードは6文字以下で入力してください',
        },
        pattern: {
            value: /^[0-9]{6}$/,
            message: '認証コードは6桁の数字で入力してください',
        },
    },
    work_pdf_name: (work_pdf_name) => ({
        required: {
            value: work_pdf_name,
            message: '1文字以上入力してください',
        },
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => {
            // 任意入力のため、値が空で「保存」された場合は、記号に関するバリデーションをスキップ
            if (!value) return true;

            // 値が空ではない場合のバリデーション
            const regex = /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/;
            return regex.test(value) || '全角記号で入力してください';
        }
    }),
    work_pdf_file: (work_pdf_name) => ({
        required: {
            value: work_pdf_name,
            message: 'PDFファイルを選択してください',
        },
        validate: value => {
            // 任意入力のため、値が空で「保存」された場合は、記号に関するバリデーションをスキップ
            if (!value) return true;
            return value.type === 'application/pdf' || 'PDFファイルのみアップロードできます';
        }
    }),
    work_name: (work_url) => ({
        required: {
            value: work_url,
            message: '1文字以上入力してください',
        },
        maxLength: {
            value: 50,
            message: '50文字以内で入力してください',
        },
        validate: value => {
            // 任意入力のため、値が空で「保存」された場合は、記号に関するバリデーションをスキップ
            if (!value) return true;

            // 値が空ではない場合のバリデーション
            const regex = /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/;
            return regex.test(value) || '全角記号で入力してください';
        }
    }),
    work_url: (work_name) => ({
        required: {
            value: work_name,
            message: 'URLを入力して下さい',
        },
        validate: value => {
            // 任意入力のため、値が空で「保存」された場合は、記号に関するバリデーションをスキップ
            if (!value) return true;

            // 値が空ではない場合のバリデーション
            return /^(http|https):\/\/[^ "]+$/.test(value) || 'URLを入力して下さい'
        }
    }),
    profile_birthdate: {
        isValidYearString: {
            required: '年は必須です',
            validate: (yearStr) => {
                // YYYY (1900 to currentYear)
                const currentYear = new Date().getFullYear();
                return (/^\d{4}$/.test(yearStr) && Number(yearStr) >= 1900 && Number(yearStr) <= currentYear) || `年は1900年から${currentYear}年までの範囲で入力してください`;
            }
        },
        isValidMonthString: {
            required: '月は必須です',
            validate: (monthStr) => {
                // 01 to 12
                return (/^(0[1-9]|1[0-2])$/.test(monthStr)) || '月は01月から12月までの範囲で入力してください';
            }
        },
        isValidDayString: {
            required: '日は必須です',
            validate: (dayStr) => {
                // 01 to 31
                return (/^(0[1-9]|[12]\d|3[01])$/.test(dayStr)) || '日は01日から31日までの範囲で入力してください';
            }
        },
        isValidFullDateString: {
            message: '正しい生年月日を入力してください',
            validate: (yearStr, monthStr, dayStr) => {
                if (!validationSchema.profile_birthdate.isValidYearString.validate(yearStr) ||
                    !validationSchema.profile_birthdate.isValidMonthString.validate(monthStr) ||
                    !validationSchema.profile_birthdate.isValidDayString.validate(dayStr)) {
                    return false;
                }

                const year = Number(yearStr);
                const month = Number(monthStr);
                const day = Number(dayStr);

                // Date object check for leap years and month lengths
                const date = new Date(year, month - 1, day);
                return date.getFullYear() === year &&
                    date.getMonth() === month - 1 &&
                    date.getDate() === day;
            }
        },
    },
    memo: (memo) => ({
        maxLength: {
            value: 1000,
            message: '1000文字以内で入力してください',
        },
        validate: value => {
            // 任意入力のため、値が空で「保存」された場合は、記号に関するバリデーションをスキップ
            if (!value) return true;

            // 値が空ではない場合のバリデーション
            const regex = /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/;
            return regex.test(value) || '全角記号で入力してください';
        }
    }),
};

// 値が空出ない場合のバリデーション
const regex = /^[^!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]+$/;
// 共通バリデーション関数
const validateField = (value, label) => {
    if (value.length > 50) return `${label}は50文字以内で入力してください`;
    if (!regex.test(value)) return `${label}は全角記号で入力してください`;
    return null;
};

// メインのバリデーション関数
export const environmentValidation = (category, typeValue, conValue) => {
    const categoryNames = {
        server: 'サーバー',
        client: 'クライアント',
        dev: '開発',
        cloud: 'クラウド',
        pc: '作業PC',
        network: 'ネットワーク'
    };

    const label = categoryNames[category];

    // 相互依存チェック
    if (typeValue && !conValue) return `${label}の詳細を選択してください`;
    if (!typeValue && conValue) return `${label}の項目を選択してください`;

    // typeValue のバリデーション
    if (typeValue) {
        const error = validateField(typeValue, `${label}タイプ`);
        if (error) return error;
    }

    // conValue のバリデーション
    if (conValue) {
        const error = validateField(conValue, `${label}詳細`);
        if (error) return error;
    }

    return true;
};